import React from 'react';
import PropTypes from 'prop-types';
import { defaultMessages } from '../../../../libs/i18n/default';
import ReactOnRails from 'react-on-rails';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import ProgressBar from 'react-bootstrap/lib/ProgressBar';
import { get } from 'lodash';
import { connect } from 'react-redux';

const mapStateToProps = (state) =>
  ({
    disableTitleField: state.territory.disable_host_photos_title_field
  });

class PhotoForm extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      method: (this.props.photo.id ? 'PUT' : 'POST'),
      id: this.props.photo.id,
      name: this.props.photo.name,
      description: this.props.photo.description,
      kind: this.props.photo.kind,
      file: null,
      image: {
        small: this.props.photo.image.small,
        medium: this.props.photo.image.medium
      },
      isValidPhotoFormat: false
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleFileSelection = this.handleFileSelection.bind(this);
    this.submit = this.submit.bind(this);
    this.disableSubmitButton = this.disableSubmitButton.bind(this);
    this.buttonTitle = this.buttonTitle.bind(this);
    this.loadingAnimation = this.loadingAnimation.bind(this);
    this.kindField = this.kindField.bind(this);
    this.formValid = this.formValid.bind(this);
  }

  formValid(){
    return(
      (this.props.photo.id || (this.state.file && this.state.isValidPhotoFormat)) &&
      (!this.props.photoKinds || this.state.kind)
    )
  }

  disableSubmitButton(){
    return this.state.submitted || !this.formValid()
  }

  handleChange(e) {
    if (e.target.id == 'kind' && e.target.value != 'other'){
      this.setState({description: ''})
    }
    this.setState({[e.target.id]: e.target.value});
  }

  handleFileSelection(e){
    this.setState({file: e.target.files[0]})

    if (e.target.files[0].type === 'image/png' || e.target.files[0].type === 'image/jpeg') {
      this.setState({isValidPhotoFormat: true})
    } else {
      this.setState({isValidPhotoFormat: false})
    }
  }

  submit(e){
    e.preventDefault();
    this.setState({submitted: true})

    let payload = {
      method: this.state.method,
      form: {
        authenticity_token: ReactOnRails.authenticityToken(),
        host_id: this.props.user.host.id,
        resident_id: get(this.props, 'resident.id', ''),
        room_id: get(this.props, 'room.id', ''),
        photo: {
          id: this.state.id,
          name: this.state.name,
          kind: this.state.kind,
          description: this.state.description,
          file: this.state.file
        }
      }
    }
    this.props.onPhotoFormSubmit(payload);
  }

  buttonTitle(){
    let pre_submit_title  = this.props.photo.id ? defaultMessages.clientHostPagesPhotoButtonsUpdate : defaultMessages.clientHostPagesPhotoButtonsCreate;
    let post_submit_title = defaultMessages[`clientHostPagesPhotoButtons${this.props.uploader.status || 'Uploading'}`];
    return this.state.submitted ? post_submit_title : pre_submit_title;
  }

  loadingAnimation() {
    if (this.state.submitted) {
      return (<i className='fa fa-spinner fa-spin fa-lg fa-fw'></i>)
    }
  }

  componentWillReceiveProps(nextProps){
     if (nextProps.didInvalidate == false && this.state.submitted && (this.state.closeWindow == undefined || this.state.closeWindow == false)) {
       this.setState({closeWindow: true})
       this.props.onClose();
     }
  }

  kindField(){
    if(this.props.photoKinds){
      const { formatMessage } = this.props.intl;
      const defaultKind = this.state.kind
      const photoOptions = this.props.photoKinds.map(opt => {
        return (<option key={opt[1]} value={opt[1]}>{opt[0]}</option>);
      })
      return(
        <FormGroup>
          <ControlLabel>{formatMessage(defaultMessages.clientHostPagesPhotoLabelsKind)}</ControlLabel>
          <FormControl id={'kind'}
            type="text"
            defaultValue={defaultKind}
            componentClass="select"
            onChange={this.handleChange}>
            <option key='no_select' value="">{formatMessage(defaultMessages.clientCommonSelectsSelect)}</option>
            {photoOptions}
          </FormControl>
        </FormGroup>
      )
    } else {
      return(null);
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    const ButtonTitle = this.buttonTitle();
    const DisableSubmitButton = this.disableSubmitButton();
    const LoadingAnimation = this.loadingAnimation();

    return (
      <div>
        <form className="signup-form">
          {
            (this.props.photo.id) &&
            <img src={this.props.photo.image.small} className="img-polaroid"/>
          }

          {
            (this.props.photo.id) &&
            <FormControl id={'id'} type='hidden' defaultValue={this.props.photo.id} />
          }

          {
            this.props.alertContent &&
            <div className="alert alert-info" style={{textAlign: 'center'}}>
              {this.props.alertContent}
            </div>
          }

          {
            !this.props.disableTitleField &&
            <FormGroup>
              <ControlLabel>{formatMessage(defaultMessages.clientHostPagesPhotoLabelsTitle)}</ControlLabel>
              <FormControl
                id="name"
                placeholder={formatMessage(defaultMessages.clientHostPagesPhotoPlaceholdersName)}
                type="text"
                componentClass="input"
                defaultValue={this.state.name}
                onChange={this.handleChange} />
            </FormGroup>
          }

          {
            (!this.props.photo.id) &&
            <FormGroup>
              <p>
                <small>{formatMessage(defaultMessages.clientCommonInvalidPhotoFormat)}</small>
              </p>
              <FormControl id="file"
                type="file"
                accept="image/png, image/jpeg"
                componentClass="input"
                onChange={this.handleFileSelection}
              />
            </FormGroup>
          }

          {this.kindField()}

          {
            this.props.photoKinds &&
            this.state.kind == 'other' &&
            <FormGroup>
              <ControlLabel>{formatMessage(defaultMessages.clientHostPagesPhotoLabelsDescription)}</ControlLabel>
              <FormControl
                id="description"
                type="text"
                placeholder={formatMessage(defaultMessages.clientCommonDetails)}
                componentClass="input"
                defaultValue={this.state.description}
                onChange={this.handleChange} />
            </FormGroup>
          }
          {this.props.uploader.progress && (
            <ProgressBar now={this.props.uploader.progress} label={`${this.props.uploader.progress}%`} active striped />
          )}
          <Button id="photo-submit" className="btn-primary" onClick={this.submit} disabled={DisableSubmitButton}>
            {LoadingAnimation} {formatMessage(ButtonTitle)}
          </Button>
        </form>
      </div>
    )
  }
};

PhotoForm.propTypes = {
   onHostProfileSubmit: PropTypes.func,
   onSkipSubmit: PropTypes.func,
   onGoBack: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};

export default connect(mapStateToProps)(PhotoForm)
